module["exports"] = [
  "New South Wales",
  "Queensland",
  "Northern Territory",
  "South Australia",
  "Western Australia",
  "Tasmania",
  "Australian Capital Territory",
  "Victoria"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_AU/address/state.js
// module id = 761
// module chunks = 0